import React, { useState, useEffect } from 'react';
import './FullScreenLoading.css';
import IconStrikeAnimation from '../Animation/IconStrikeAnimation';

const FullScreenLoading = ({ isMobile, progress, loadingErrorMessage }) => {

  const [currentQuote, setCurrentQuote] = useState(0);
  
  // 小语种学习相关名言
  const quotes = [
    "语言是通向世界的桥梁",
    "学一门新语言，开一个新世界",
    "多一种语言，多一种思维方式",
    "坚持是学习语言的最高境界",
    "语言学习没有捷径，但有方法",
    "每种语言都是独特的思维模式",
    "不要害怕犯错，害怕的应该是不敢尝试",
    "语言是文化的钥匙，坚持是成功的密码"
  ];
  
  useEffect(() => {
    // 每3秒更换一次名言
    const quoteTimer = setInterval(() => {
      setCurrentQuote(prev => (prev + 1) % quotes.length);
    }, 1000);
    
    return () => {
      // clearInterval(progressTimer);
      clearInterval(quoteTimer);
    };
  }, [quotes.length]);
  
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-header">
          <div className="loading-logo">
            <img src="/logo.png" alt="logo" />
          </div>
          {/* <div className="loading-logo">OLACIO.COM</div>
          <h1 className="loading-title">欧那小语种在线教育</h1> */}
          {/* <div className="loading-subtitle">正在加载您的学习环境...</div> */}
        </div>
        
        <div className="loading-progress-animation">
          <IconStrikeAnimation />
        </div>
        
        <div className="loading-progress-container">
          <div className="loading-progress-track">
            <div 
              className="loading-progress-bar" 
              style={{ width: `${progress}%` }}
            >
              <div className="loading-progress-glow"></div>
            </div>
          </div>
        </div>
        
        <div className="loading-quote-container">
          <div className="loading-quote">{quotes[currentQuote]}</div>
          <div className="loading-quote-author">— 小语种学习箴言</div>
        </div>
        
        {!loadingErrorMessage && ( 
          <div className="loading-progress-info">
            <div className="loading-progress-percent">{progress}%</div>
            <div className="loading-progress-text">资源加载中...</div>
          </div>
        )}
        {loadingErrorMessage && ( 
          <div className="loading-progress-error">
            <span>{loadingErrorMessage}</span>
          </div>
        )}
        
        <div className="loading-globe">
          <div className="loading-globe-inner"></div>
          <div className="loading-globe-ring"></div>
        </div>
      </div>
      {!isMobile  && (
        <div className="loading-background-elements">
          <div className="loading-bg-circle loading-bg-circle-1"></div>
          <div className="loading-bg-circle loading-bg-circle-2"></div>
          <div className="loading-bg-circle loading-bg-circle-3"></div>
        </div>
      )}
    </div>
  );
};

export default FullScreenLoading;